import { Alert } from '@mui/material';
import { useIsDirector } from 'shared/permissions/useIsDirector';
import { useIsSupplier } from 'shared/permissions/useIsSupplier';
import { useIsTechnician } from 'shared/permissions/useIsTechnician';
import { useIsTechnicianCoordinator } from 'shared/permissions/useIsTechnicianCoordinator';
import { ITransportDocument } from 'features/inventory/transport-documents/types';
import { useTranslation } from 'react-i18next';
import TransportDocumentForm from '../form/TransportDocumentForm';

interface BaseInfoTabProps {
  ddt: ITransportDocument;
  onSubmit: (values: any) => void;
}

export function BaseInfoTab({ ddt, onSubmit }: BaseInfoTabProps) {
  const { t } = useTranslation();
  const prefix = 'pages.ddt.detail';
  const showAlert = ddt.amount != null && Number(ddt.amount) !== Number(ddt.expected_amount);
  const isDisableEdit =
    useIsTechnicianCoordinator() || useIsTechnician() || useIsSupplier() || useIsDirector();

  return (
    <>
      {showAlert && (
        <Alert severity="warning" sx={{ width: '100%', mb: 3, borderRadius: 2 }}>
          {t(`${prefix}.incoerent-amounts`)}
        </Alert>
      )}
      <TransportDocumentForm
        onSubmit={onSubmit}
        transport_document={ddt}
        disableEdit={isDisableEdit}
      />
    </>
  );
}

export default BaseInfoTab;
